import axios from "axios";

// const API = axios.create({ baseURL: 'http://localhost:5000'})
const API = axios.create({ baseURL: process.env.REACT_APP_API });
const localuser = localStorage.getItem("profile");
API.interceptors.request.use((req) => {
  if (localuser) {
    req.headers.authorization = `Bearer ${JSON.parse(localuser).token}`;
  }

  return req;
});

// export const fetchInvoices =() => API.get('/invoices')
export const fetchInvoice = (id) => API.get(`/invoices/${id}`);
export const addInvoice = (invoice) => API.post("/invoices", invoice);
export const updateInvoice = (id, updatedInvoice) =>
  API.patch(`/invoices/${id}`, updatedInvoice);
export const deleteInvoice = (id) => API.delete(`/invoices/${id}`);
export const fetchInvoicesByUser = (searchQuery, page) =>
  API.get(`/invoices?searchQuery=${searchQuery.search}&page=${page}`);
export const fetchInvoicesByRental = (rentalId) =>
  API.get(`/invoices/byRental/${rentalId}`);
export const fetchInvoiceNumberByUser = (searchQuery) =>
  API.get(`/invoices/lastInvoice?searchQuery=${searchQuery.search}`);
export const downloadPdfInvoice = (id, lang) =>
  API.get(`/invoices/pdf/${id}/${lang}`, {
    responseType: "blob",
  });

export const emailPdfInvoice = (id) =>
  API.patch(`/invoices/pdf/${id}/send`, {});

export const fetchClient = (id) => API.get(`/clients/${id}`);
export const fetchClients = (page) => API.get(`/clients?page=${page}`);
export const addClient = (client) => API.post("/clients", client);
export const updateClient = (id, updatedClient) =>
  API.patch(`/clients/${id}`, updatedClient);
export const deleteClient = (id) => API.delete(`/clients/${id}`);
export const fetchClientsByUser = (searchQuery, page) =>
  API.get(`/clients/user?searchQuery=${searchQuery.search}&page=${page}`);
export const fetchClientsBySearchQuery = (searchQuery, page) =>
  API.get(`/clients/search?searchQuery=${searchQuery.search}&page=${page}`);

export const signIn = (formData) => API.post("/users/signin", formData);
export const signUp = (formData) => API.post("/users/signup", formData);
export const forgot = (formData) =>
  API.post("/users/forgot-password", formData);
export const reset = (formData) => API.post("/users/reset", formData);

export const fetchProfilesBySearch = (searchQuery) =>
  API.get(
    `/profiles/search?searchQuery=${
      searchQuery.search || searchQuery.year || "none"
    }`
  );
export const fetchProfile = (id) => API.get(`/profiles/${id}`);
export const fetchProfiles = () => API.get("/profiles");
export const fetchProfilesByUser = (searchQuery) =>
  API.get(`/profiles?searchQuery=${searchQuery.search}`);
export const createProfile = (newProfile) => API.post("/profiles", newProfile);
export const updateProfile = (id, updatedProfile) =>
  API.patch(`/profiles/${id}`, updatedProfile);
export const deleteProfile = (id) => API.delete(`/profiles/${id}`);

export const uploadFile = (formData) => API.post(`/upload`, formData);
export const fetchFileById = (id) => API.get(`/upload/${id}`);
export const fetchFilesByUser = (searchQuery) =>
  API.get(`/upload?searchQuery=${searchQuery.search}`);

export const fetchCategory = (id) => API.get(`/categories/${id}`);
export const addCategory = (Category) => API.post("/categories", Category);
export const updateCategory = (id, updatedCategory) =>
  API.patch(`/categories/${id}`, updatedCategory);
export const deleteCategory = (id) => API.delete(`/categories/${id}`);
export const fetchCategoriesByUser = (searchQuery, page) =>
  API.get(`/categories?searchQuery=${searchQuery.search}&page=${page}`);

export const fetchItem = (id) => API.get(`/items/${id}`);
export const addItem = (Item) => API.post("/items", Item);
export const updateItem = (id, updatedItem) =>
  API.patch(`/items/${id}`, updatedItem);
export const deleteItem = (id) => API.delete(`/items/${id}`);
export const fetchItemsByUser = (
  searchQuery,
  page,
  pageSize = 150,
  category = ""
) =>
  API.get(
    `/items?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}&category=${category}`
  );
export const lastModified = (searchQuery, page) =>
  API.get(`/items/lastModified?searchQuery=${searchQuery.search}`);
export const contactUs = (formData) => API.post("/contactus", formData);

export const fetchCompany = (id) => API.get(`/companies/${id}`);
export const fetchCompanies = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/companies?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const addCompany = (Company) => API.post("/companies", Company);
export const updateCompany = (id, updatedCompany) =>
  API.patch(`/companies/${id}`, updatedCompany);
export const deleteCompany = (id) => API.delete(`/companies/${id}`);
export const companyLastModified = (searchQuery, page) =>
  API.get(`/companies/lastModified?searchQuery=${searchQuery.search}`);
export const checkDomain = (domain) =>
  API.get(`/companies/check-domain?domain=${domain}`);

export const fetchUserGroup = (id) => API.get(`/groups/${id}`);
export const fetchUserGroups = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/groups?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const addUserGroup = (UserGroup) => API.post("/groups", UserGroup);
export const updateUserGroup = (id, updatedUserGroup) =>
  API.patch(`/groups/${id}`, updatedUserGroup);
export const deleteUserGroup = (id) => API.delete(`/groups/${id}`);
export const fetchRoles = () => API.get(`/groups/roles`);

export const fetchUser = (id) => API.get(`/users/${id}`);
export const fetchUsers = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/users?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const addUser = (User) => API.post("/users", User);
export const updateUser = (id, updatedUser) =>
  API.patch(`/users/${id}`, updatedUser);
export const deleteUser = (id) => API.delete(`/users/${id}`);

export const fetchRents = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/rentals?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const fetchUnpaidRents = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/rentals/unpaid?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );

export const fetchRent = (id) => API.get(`/rentals/${id}`);
export const addRent = (Rent) => API.post("/rentals", Rent);
export const updateRent = (id, updatedRent) =>
  API.patch(`/rentals/${id}`, updatedRent);
export const deleteRent = (id) => API.delete(`/rentals/${id}`);

export const fetchUnits = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/units?searchQuery=${searchQuery.search}&isVacant=${searchQuery.isVacant}&page=${page}&pageSize=${pageSize}`
  );
export const fetchUnit = (id) => API.get(`/units/${id}`);
export const addUnit = (Unit) => API.post("/units", Unit);
export const updateUnit = (id, updatedUnit) =>
  API.patch(`/units/${id}`, updatedUnit);
export const deleteUnit = (id) => API.delete(`/units/${id}`);

export const fetchBuildings = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/buildings?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const fetchBuilding = (id) => API.get(`/buildings/${id}`);
export const addBuilding = (Building) => API.post("/buildings", Building);
export const updateBuilding = (id, updatedBuilding) =>
  API.patch(`/buildings/${id}`, updatedBuilding);
export const deleteBuilding = (id) => API.delete(`/buildings/${id}`);

export const fetchTransactions = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/transactions?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const fetchTransaction = (id) => API.get(`/transactions/${id}`);
export const addTransaction = (Transaction) =>
  API.post("/transactions", Transaction);
export const updateTransaction = (id, updatedTransaction) =>
  API.patch(`/transactions/${id}`, updatedTransaction);
export const deleteTransaction = (id) => API.delete(`/transactions/${id}`);
export const fetchTrialBalance = () => API.get(`/transactions/trial-balance`);
export const fetchBalanceSheet = () => API.get(`/transactions/balance-sheet`);

export const fetchAccounts = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/accounts?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const fetchAccount = (id) => API.get(`/accounts/${id}`);
export const addAccount = (Account) => API.post("/accounts", Account);
export const updateAccount = (id, updatedAccount) =>
  API.patch(`/accounts/${id}`, updatedAccount);
export const deleteAccount = (id) => API.delete(`/accounts/${id}`);

export const fetchLetters = (searchQuery, page, pageSize = 15, letterType) =>
  API.get(
    `/letters?letterType=${letterType}&searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const fetchLetter = (id) => API.get(`/letters/${id}`);
export const addLetter = (Letter) => API.post("/letters", Letter);
export const updateLetter = (id, updatedLetter) =>
  API.patch(`/letters/${id}`, updatedLetter);
export const deleteLetter = (id) => API.delete(`/letters/${id}`);
export const downloadPdfLetter = (id, lang) =>
  API.get(`/letters/pdf/${id}/${lang}`, {
    responseType: "blob",
  });

// api/index.js

// Fetch purchase invoices with optional search query and pagination
export const fetchPurchaseInvoices = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/purchases?searchQuery=${searchQuery}&page=${page}&pageSize=${pageSize}`
  );

// Fetch a single purchase invoice by ID
export const fetchPurchaseInvoice = (id) => API.get(`/purchases/${id}`);

// Add a new purchase invoice
export const addPurchaseInvoice = (purchaseInvoice) =>
  API.post("/purchases", purchaseInvoice);

// Update an existing purchase invoice by ID
export const updatePurchaseInvoice = (id, updatedPurchaseInvoice) =>
  API.patch(`/purchases/${id}`, updatedPurchaseInvoice);

// Delete a purchase invoice by ID
export const deletePurchaseInvoice = (id) => API.delete(`/purchases/${id}`);

// Download a PDF of the purchase invoice
export const downloadPdfPurchaseInvoice = (id, lang) =>
  API.get(`/purchases/pdf/${id}/${lang}`, {
    responseType: "blob",
  });

/* Fetch the last invoice number for the current user with optional search query
 *
 * @param {Object} searchQuery - Search query object
 * @param {String} searchQuery.search - Search query string
 * @returns {Promise<Number>} Last invoice number
 */
export const fetchLastPurchaseNumber = (searchQuery) =>
  API.get(`/purchases/lastInvoice?searchQuery=${searchQuery.search}`);
export const emailPurchasePdfInvoice = (id) =>
  API.patch(`/purchases/pdf/${id}/send`, {});

export const seedAccount = () => API.post("/seed-account", null);

export const createPayroll = (payrollData) =>
  API.post("/hr/payrolls", payrollData);

export const fetchPayrolls = () => API.get(`/hr/payrolls/`);

export const recordAttendance = (attendanceData) =>
  API.post("/hr/attendances", attendanceData);

export const fetchAttendanceRecords = () => API.get(`/hr/attendances/`);

export const getBarcodeSettings = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/settings/barcode?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const getBarcodeSettingsById = (id) =>
  API.get(`/settings/barcode/${id}`);
export const createBarcodeSettings = (barcodeData) =>
  API.post(`/settings/barcode/`, barcodeData);
export const updateBarcodeSettings = (id, updatedData) =>
  API.patch(`/settings/barcode/${id}`, updatedData);
export const deleteBarcodeSettings = (id) =>
  API.delete(`/settings/barcode/${id}`);

// Tax Settings
// export const fetchAllTaxSettings = () => API.get(`/settings/tax`);
export const fetchAllTaxSettings = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/settings/tax?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const addTaxSettings = (tax) => API.post("/settings/tax/", tax);
export const fetchTaxSettingsById = (id) => API.get(`/settings/tax/${id}`);
export const updateTax = (id, newTax) =>
  API.patch(`/settings/tax/${id}`, newTax);
export const deleteTax = (id) => API.delete(`/settings/tax/${id}`);

///cost centar///
export const fetchAllCostCenters = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/cost-centers?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const addCostCenters = (costCenterData) =>
  API.post("/cost-centers", costCenterData);
export const fetchCostCenterById = (id) => API.get(`/cost-centers/${id}`);
export const updateCostCenters = (id, updateData) =>
  API.patch(`/cost-centers/${id}`, updateData);
export const deleteCostcenters = (id) => API.delete(`/cost-centers/${id}`);
export const fetchCostCenterByIdCompany = () =>
  API.get("/cost-centers/Id/company");

// Assets
export const fetchAssets = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/assets?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const fetchAssetById = (id) => API.get(`/assets/${id}`);
export const addAsset = (asset) => API.post("/assets", asset);
export const updateAsset = (id, updateData) =>
  API.patch(`/assets/${id}`, updateData);
export const deleteAsset = (id) => API.delete(`/assets/${id}`);

// profitCenters
export const getProfitCenters = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/profit-centers?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );

export const getProfitCenter = (id) => API.get(`/profit-centers/${id}`);

export const createProfitCenter = (profitCenterData) =>
  API.post("/profit-centers", profitCenterData);

export const updateProfitCenter = (id, updatedData) =>
  API.patch(`/profit-centers/${id}`, updatedData);

export const deleteProfitCenter = (id) => API.delete(`/profit-centers/${id}`);

// projects
export const getProjects = (searchQuery, page, pageSize = 10) =>
  API.get(
    `/projects?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );
export const getProject = (id) => API.get(`/projects/${id}`);

export const createProject = (ProjectsData) =>
  API.post(`/projects`, ProjectsData);

export const updateProject = (id, updatedData) =>
  API.patch(`/projects/${id}`, updatedData);

export const deleteProject = (id) => API.delete(`/projects/${id}`);

// SMS Providers
export const getSMSProviders = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/settings/sms-provider?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );

export const getSMSProvidersById = (id) => API.get(`/sms-providers/${id}`);

export const createSMSProviders = (smsData) =>
  API.post(`/settings/sms-provider`, smsData);

export const updateSMSProviders = (id, updatedData) =>
  API.patch(`/settings/sms-provider/${id}`, updatedData);

export const deleteSMSProviders = (id) =>
  API.delete(`/settings/sms-provider/${id}`);

// SMS Settings API
export const fetchSmsSettings = () => API.get("/settings/sms-settings");
export const createSmsSettings = (settings) =>
  API.post("/settings/sms-settings", settings);
export const updateSmsSettings = (id, updatedSettings) =>
  API.patch(`/settings/sms-settings/${id}`, updatedSettings);

// Notifications
export const getNotifications = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/notifications?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );

export const getNotification = (id) => API.get(`/notifications/${id}`);

export const createNotification = (notificationData) =>
  API.post("/notifications", notificationData);

export const updateNotification = (id, updatedData) =>
  API.patch(`/notifications/${id}`, updatedData);

export const deleteNotification = (id) => API.delete(`/notifications/${id}`);

///Vouchers///
export const createVouchers = () => API.post(`/vouchers`);
export const getAllVouchers = () => API.get(`/vouchers`);
export const useVouchers = () => API.post(`/vouchers/use`);
export const deleteVouchers = (code) => API.delete(`/vouchers/${code}`);

// Coupons

export const fetchCoupons = (searchQuery, page, pageSize = 15) =>
  API.get(
    `/coupons?searchQuery=${searchQuery.search}&page=${page}&pageSize=${pageSize}`
  );

export const fetchCoupon = (id) => API.get(`/coupons/${id}`);

export const fetchCouponByCode = (code) => API.get(`/coupons/code/${code}`);

export const createCoupon = (couponData) => API.post(`/coupons`, couponData);

export const updateCoupon = (id, updatedData) =>
  API.patch(`/coupons/${id}`, updatedData);

export const deleteCoupon = (id) => API.delete(`/coupons/${id}`);

// Communications
export const connectWhatsApp = () =>
  API.post(`/communication/whatsapp/connect`);
// Email
export const createSmtpConfig = (configData) =>
  API.post(`/communication/smtp/config`, configData);
export const createSmtpTest = (configData) =>
  API.post(`/communication/smtp/test`, configData);

export const fetchSmtpConfig = () => API.get(`/communication/smtp/config`);

// productPackages
export const fetchProductPackages = () => API.get(`/packages`);
export const fetchProductPackageById = (id) => API.get(`/packages/${id}`);
export const createProductPackage = (PackageData) =>
  API.post(`/packages`, PackageData);
export const updateProductPackage = (id, packageData) =>
  API.put(`/packages/${id}`, packageData);
export const deleteProductPackage = (id) => API.delete(`/packages/${id}`);
export const fetchProductPackagesByLang = (lang) =>
  API.get(`packages/lang/${lang}`);

// Features
export const fetchFeatures = () => API.get(`/features`);
export const fetchFeaturesByLang = (lang) => API.get(`/features/lang/${lang}`);
export const createFeature = (featureData) =>
  API.post(`/features`, featureData);
export const updateFeature = (id, updatedData) =>
  API.put(`/features/${id}`, updatedData);
export const deleteFeature = (id) => API.delete(`/features/${id}`);

// Translation
export const translate = (text) => API.post(`/translation`, text);

// Account Settings
export const fetchAccountSettings = () => API.get(`/settings/accounting`);
export const createAccountSettings = (newAccountSettings) =>
  API.post(`/settings/accounting`, newAccountSettings);
export const updateAccountSettings = (updatedData) =>
  API.put(`/settings/accounting`, updatedData);

// Properties
export const fetchProperties = (filters = {}, page = 1, pageSize = 10) => {
  const queryParams = new URLSearchParams();
  if (filters.propertyType)
    queryParams.append("propertyType", filters.propertyType);
  if (filters.listingPurpose)
    queryParams.append("listingPurpose", filters.listingPurpose);
  if (filters.propertyStatus)
    queryParams.append("propertyStatus", filters.propertyStatus);
  if (filters.minPrice) queryParams.append("minPrice", filters.minPrice);
  if (filters.maxPrice) queryParams.append("maxPrice", filters.maxPrice);
  if (filters.city) queryParams.append("city", filters.city);
  queryParams.append("page", page);
  queryParams.append("pageSize", pageSize);

  return API.get(`/property?${queryParams.toString()}`);
};

export const fetchProperty = (id) => API.get(`/property/${id}`);
export const createProperty = (propertyData) =>
  API.post("/property", propertyData);
export const updateProperty = (id, propertyData) =>
  API.patch(`/property/${id}`, propertyData);
export const deleteProperty = (id) => API.delete(`/property/${id}`);
export const searchProperties = (
  searchParams = {},
  page = 1,
  pageSize = 10
) => {
  const queryParams = new URLSearchParams();
  if (searchParams.searchTerm)
    queryParams.append("searchTerm", searchParams.searchTerm);
  if (searchParams.propertyType)
    queryParams.append("propertyType", searchParams.propertyType);
  if (searchParams.minPrice)
    queryParams.append("minPrice", searchParams.minPrice);
  if (searchParams.maxPrice)
    queryParams.append("maxPrice", searchParams.maxPrice);
  if (searchParams.city) queryParams.append("city", searchParams.city);
  if (searchParams.listingPurpose)
    queryParams.append("listingPurpose", searchParams.listingPurpose);
  queryParams.append("page", page);
  queryParams.append("pageSize", pageSize);

  return API.get(`/property/search?${queryParams.toString()}`);
};

// Properties
export const fetchNewProperties = () => API.get(`/properties`);
export const fetchPropertyById = (id) => API.get(`/properties/${id}`);
export const createNewProperty = (data) => API.post(`/properties`, data);
export const updateProperties = (id, data) =>
  API.patch(`/properties/${id}`, data);
export const deleteProperties = (id) => API.delete(`/properties/${id}`);
export const deleteAttachment = (id, fileId) =>
  API.delete(`/properties/${id}/attachments/${fileId}`);
export const addAttachments = (id, data) =>
  API.post(`/properties/${id}/attachments`, data);
export const uploadAttachments = (data) => API.post(`/upload/multiple`, data);

// Messaging API
export const fetchConversations = () =>
  API.get("/messaging/conversations");
export const fetchConversation = (id) =>
  API.get(`/messaging/conversations/${id}`);
export const createConversation = (conversationData) =>
  API.post("/messaging/conversations", conversationData);
export const updateConversation = (id, updateData) =>
  API.patch(`/messaging/conversations/${id}`, updateData);
export const deleteConversation = (id) =>
  API.delete(`/messaging/conversations/${id}`);
export const fetchMessages = (conversationId, page = 1, limit = 50) =>
  API.get(
    `/messaging/conversations/${conversationId}/messages?page=${page}&limit=${limit}`
  );
export const sendMessage = (conversationId, messageData) =>
  API.post(
    `/messaging/conversations/${conversationId}/messages`,
    messageData
  );
export const deleteMessage = (conversationId, messageId) =>
  API.delete(
    `/messaging/conversations/${conversationId}/messages/${messageId}`
  );
export const addParticipant = (conversationId, userData) =>
  API.post(
    `/messaging/conversations/${conversationId}/participants`,
    userData
  );
export const removeParticipant = (conversationId, userId) =>
  API.delete(
    `/messaging/conversations/${conversationId}/participants/${userId}`
  );
export const fetchUnreadCount = () => API.get("/messaging/messages/unread/count");
export const markAsRead = (conversationId) =>
  API.patch(`/messaging/messages/${conversationId}/read`);
export const uploadMessageAttachment = (conversationId, formData) =>
  API.post(
    `/messaging/conversations/${conversationId}/attachments`,
    formData
  );
export const deleteMessageAttachment = (conversationId, attachmentId) =>
  API.delete(
    `/messaging/conversations/${conversationId}/attachments/${attachmentId}`
  );
